import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../../service/auth.service';
import { relatorio } from '../../../../modal/relatorio';
import { RelatorioService } from '../../../../service/relatorio.service';
import { EditorConfigService } from '../../../../service/editorTextoConfig.service';
import { QuillModule } from 'ngx-quill';
import { ConfirmDialogComponent } from '../../dialog/confirmdialog.component';

@Component({
  selector: 'app-cadastro-adicionar-relatorio',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    FormsModule,
    MatPaginatorModule,
    QuillModule
  ],
  templateUrl: './cadastro-adicionar-relatorio.component.html',
  styleUrl: './cadastro-adicionar-relatorio.component.scss'
})

export class CadastroAdicionarRelatorioComponent implements OnInit{
  @ViewChild('mySelectRelatorio') mySelectRelatorio: any;
  data : any[]=[];
  public lista: relatorio[] = [];
  novoItem: relatorio = new relatorio();
  editorConfig: any;
  EhEtapa1 = true;
  public TravaEtapa = false;
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 25];
  listaIndEtapa1: relatorio[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private relatorioService: RelatorioService,
    private editorConfigHtml: EditorConfigService,
    public dialog: MatDialog,
    private authService: AuthService) {
    try{
      let login = localStorage.getItem('login');
      if(login == null || login == undefined)
        this.router.navigate(['/iniciar']);
      }
      catch(ex)
      {
        this.router.navigate(['/iniciar']);
      }
  }
  submitForm() {

    if (this.novoItem.descricao == "") {
      alert("Digite todos os campos obrigatorios!")
      return;
    }

    //console.log('Novo item', this.novoItem);
    this.relatorioService.adicionarItem(this.novoItem).subscribe(() => {
      //console.log('Novo item adicionado com sucesso', this.novoItem);
      this.novoItem = new relatorio();
      this.authService.atualizarListaPostosERegiaoUsuario();
      this.router.navigate(['relatorio-listagem']);
    }, (error: any) => {
      console.error('Erro ao adicionar novo item:', error);
    });

  }

  onOptionChange(newValue: string) {
    console.log(newValue);
    let IndicadorSelecionado = this.listaIndEtapa1.find(x => x.codigo == Number.parseInt(newValue))
    this.novoItem.codigo = IndicadorSelecionado?.codigo;
    this.novoItem.nome = IndicadorSelecionado?.nome == undefined ? "" : IndicadorSelecionado?.nome;
    this.novoItem.descricao = IndicadorSelecionado?.descricao == undefined ? "" : IndicadorSelecionado?.descricao;
    this.novoItem.colecao = IndicadorSelecionado?.colecao == undefined ? "" : IndicadorSelecionado?.colecao;
  }


  Limpar()
  {
    this.novoItem = new relatorio();
  }

  ngOnInit() {
    this.editorConfig = this.editorConfigHtml.getEditorConfig();
    this.route.queryParams.subscribe(params => {
      let idEditar = params['IdEditar'];

      this.relatorioService.getFindAllEtapas1().pipe(
        ).subscribe((response) => {
          this.listaIndEtapa1 = response["Relatorio"];
          if (idEditar == undefined) {
            this.novoItem.codigo = this.obterMaiorCodigo() + 1;
            this.novoItem.etapa = 1;
            this.EhEtapa1 = true;
          }
          else
            this.TravaEtapa = true;
          
          if(idEditar!=undefined)
            this.AbrirEditarItem(idEditar);
        });


    });
    
  }

  validateAndFormat(consulta: string): void {
      this.novoItem.consulta = this.newJson(consulta);
  }

  newJson(valor: string | undefined) {
    if (valor == undefined)
      return "";
    try {
      const jsonObject = JSON.parse(valor.replaceAll(/(#[^#]+#)/g, "\"$1\""));
      return JSON.stringify(jsonObject, null, 2).replaceAll("\"#", "#").replaceAll("#\"", "#");
    } catch (error: unknown) {
      if (error instanceof Error) {
        alert('Erro no JSON: ' + error.message);
      } else {
        alert('Erro desconhecido');
      }
      return valor;
    }
  }

  handleInputChange(event: any) {
    const inputValue = event.target.value;
    if (inputValue == 1) {
      this.EhEtapa1 = true;
      this.novoItem.codigo = this.obterMaiorCodigo() + 1;
    }
    else
      this.EhEtapa1 = false;
  }

  obterMaiorCodigo(): number {
    let maiorCodigo = -Infinity; // Inicializa com um valor muito baixo
    for (const objeto of this.listaIndEtapa1) {
      if (objeto.codigo != undefined)
        if (objeto.codigo > maiorCodigo) {
          maiorCodigo = objeto.codigo;
        }
    }
    console.log(maiorCodigo)
    return maiorCodigo;
  }

  AbrirEditarItem(id: string | null): void {
    if (id != undefined) {
      this.relatorioService.editarItem(id?.toString()).subscribe(
        (response) => {
          console.log(response);
          let p = response;

          this.novoItem.id = p['id'];
          this.novoItem.codigo = p['codigo'];
          this.novoItem.etapa = p['etapa'];
          if(this.novoItem.etapa == 1)
          {
            this.EhEtapa1 = true;
          }
          else{
            this.EhEtapa1 = false;
            this.mySelectRelatorio.nativeElement.value = this.novoItem.codigo;
          }
          this.novoItem.nome = p['nome'];
          this.novoItem.descricao = p['descricao'];
          this.novoItem.consulta = p['consulta'];
          this.novoItem.colecao = p['colecao'];
          this.novoItem.textoAjudaHTML = p['textoAjudaHTML'];
        },
        (error) => {
          console.error('Erro ao excluir o item:', error);
        }
      );
    }
  }

  alterarTravaEtapa(novoStatus: boolean) {
    if (novoStatus == false) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: { title: 'Confirmação', message: 'Tem certeza que deseja editar a etapa do indicador? lembre-se que deverá fazer alterações para se adequar a nova etapa.' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.TravaEtapa = novoStatus;
        }
      });
    }
    else
      this.TravaEtapa = novoStatus;
  }
}
